export enum DataNdaTermsType {
    NA,
    OneYear,
    TwoYears,
    ThreeYears,
}

export const DataNdaTermsTypeList = [
    { id: DataNdaTermsType.NA, label: 'NA', key: 'Na' },
    { id: DataNdaTermsType.OneYear, label: '1 Year', key: 'OneYear' },
    { id: DataNdaTermsType.TwoYears, label: '2 Years', key: 'TwoYears' },
    { id: DataNdaTermsType.ThreeYears, label: '3 Years', key: 'ThreeYears' },
];